import { ele } from "cables-shared-client";
import api from "./api.js";
import web from "./index.js";

export default class Nav
{
    constructor()
    {
        this._lastPatchTemplates = 0;
        this._lastRecentProjects = "recentpatches";

        this._infoBar = {
            "text": "",
            "classes": []
        };

        const mailEle = document.querySelector(".page-footer__link--email");
        if (mailEle)
        {
            const hi = "hi";
            const hi2 = "undev";
            const hi3 = "de";

            mailEle.onclick = () =>
            {
                const a = document.createElement("a");
                a.href = "mai" + "lto:" + hi + "@" + hi2 + "." + hi3;
                a.click();
            };
        }

        if (web.env.isDev())
        {
            this.showInfoBar("<a href=\"/docs/faq/general/dev/dev\">dev environment</a> - here be dragons!  <a href=\"/ops/changelog\">op changelog</a> | <a href=\"/standalone\">standalone download</a>");
        }
        const announcement = ele.byId("announcementMessage");
        if (announcement)
        {
            this.showInfoBar(announcement.innerHTML, announcement.dataset.level);
        }
        const maintenance = ele.byId("maintenanceMessage");
        if (maintenance)
        {
            const state = maintenance.dataset.state;
            if (state === "active")
            {
                if (web.env.loggedIn)
                {
                    this.showInfoBar("MAINTENANCE MODE: site is closed for normal users!");
                }
                else
                {
                    this.showInfoBar("cables is currently in maintenance mode, login and registration are disabled, please come back later");
                }
            }
            if (state === "scheduled")
            {
                const schedule = maintenance.dataset.schedule;
                const date = new Date(Date.parse(schedule));
                const dateMoment = moment(date).format("DD.MM.YYYY HH:mm");
                const timeZone = "Europe/Berlin";
                this.showInfoBar("SCHEDULED DOWNTIME: site will be closed for approx. one to three hours at " + dateMoment + " (" + timeZone + ")", "info");
            }
        }

        const darkModeTurnOn = document.querySelector("#nav-bar-avatar-dropdown .dark-theme");
        const lightModeTurnOn = document.querySelector("#nav-bar-avatar-dropdown .light-theme");

        document.body.style.transition = "background-color 0.3s ease-out";
        if (darkModeTurnOn)
        {
            darkModeTurnOn.addEventListener("click", () =>
            {
                fetch("/api/user/settings/theme/dark");

                if (document.body)
                {
                    document.body.classList.remove("light");
                    document.body.classList.add("dark");
                }
            });
        }
        if (lightModeTurnOn)
        {
            lightModeTurnOn.addEventListener("click", () =>
            {
                fetch("/api/user/settings/theme/light");

                if (document.body)
                {
                    document.body.classList.remove("dark");
                    document.body.classList.add("light");
                }
            });
        }
        this.getMyProjectListNav();
    }

    newProject()
    {
        api.post("project/", null, (result) =>
        {
            const id = result.shortId || result._id;
            document.location.href = "/edit/" + id;
        });
    }

    showInfoBar(text, level = "neutral", saveState = true)
    {
        if (!level) level = "neutral";

        if (web.isOnBeforeUnload) return;
        if (level === "error" && !web.env.loggedIn) return;

        const bar = document.getElementById("nav-infobar");
        if (bar)
        {
            bar.innerHTML = decodeURIComponent(text);
            bar.classList.remove("warning");
            bar.classList.remove("info");
            bar.classList.remove("neutral");
            bar.classList.remove("hidden");
            bar.classList.add(level);
            if (saveState)
            {
                this._infoBar.text = bar.innerHTML;
                this._infoBar.classes = Array.from(bar.classList);
            }
        }
    }

    resetInfoBar()
    {
        if (!this._infoBar || !this._infoBar.text) return;
        const bar = document.getElementById("nav-infobar");
        if (bar)
        {
            bar.innerHTML = this._infoBar.text;
            if (this._infoBar.classes)
            {
                this._infoBar.classes.forEach((c) =>
                {
                    bar.classList.add(c);
                });
            }
        }
    }

    getTemplateListNav()
    {
        if (this._lastPatchTemplates === 0)
        {
            this._lastPatchTemplates = Date.now();
            api.get("templates", (result) =>
            {
                web.setHandleBarHtml("nav_patch_templates", { "templates": result }, ele.byId("template-list-dropdown"));
            });
        }
    }

    getMyProjectListNav(which)
    {
        if (which === "recentpatches" && this._lastRecentProjects === which)
        {
            document.location.href = "/mypatches";
            return;
        }
        if (which === "recentinvitedpatches" && this._lastRecentProjects === which)
        {
            document.location.href = "/mypatches#sharedme";
            return;
        }

        if (which === "teams" && this._lastRecentProjects === which)
        {
            document.location.href = "/myteams";
            return;
        }

        if (which === "patchlists" && this._lastRecentProjects === which)
        {
            document.location.href = "/mypatchlists";
            return;
        }

        const dropDown = document.getElementById("my-recent-projects-dropdown");
        if (!dropDown) return;
        dropDown.innerHTML = "<div class=\"loading\"></div>";

        document.getElementById("mypatches_" + this._lastRecentProjects).classList.remove("myPatchesFilterActive");
        document.getElementById("mypatches_" + this._lastRecentProjects).classList.add("myPatchesFilterInActive");

        which = which || "recentpatches";
        document.getElementById("mypatches_" + which).classList.add("myPatchesFilterActive");
        document.getElementById("mypatches_" + which).classList.remove("myPatchesFilterInActive");

        this._lastRecentProjects = which;

        let apiEndpoint = which;
        if (which === "teams") apiEndpoint = "teams/myteams?l=4";
        if (which === "patchlists") apiEndpoint = "patchlists/mylists/all?l=4";

        api.get(apiEndpoint, (result) =>
        {
            const nProjects = 4;
            let html = "";

            if (which === "teams")
            {
                if (result.data.length === 0)
                    html += "<div class=\"text-center\">No teams yet!<br/><br/></div>";

                if (result.data.length > nProjects) result.data.length = nProjects;

                for (const i in result.data)
                    html += web.getHandleBarHtml("team_thumb", result.data[i]);

                html += "<div class=\"text-center\"><a class=\"button-small\"href=\"/myteams\">Manage your teams</a></div>";
            }
            else if (which === "patchlists")
            {
                if (result.data.length === 0)
                    html += "<div class=\"text-center\">No lists yet!<br/><br/></div>";

                if (result.data.length > nProjects) result.data.length = nProjects;

                for (const i in result.data)
                {
                    const list = result.data[i];
                    const projectInfo = web.getHandleBarHtml("project_info", { "project": list, "user": list.owner });
                    html += web.getHandleBarHtml("patchlist_thumb", { "list": list, "projectInfo": projectInfo });
                }

                html += "<div class=\"text-center\"><a class=\"button-small\"href=\"/mypatchlists\">Manage your lists</a></div>";
            }
            else
            {
                if (result.msg) result = result.msg;
                if (result.length === 0) html = "";
                if (result.length > nProjects) result.length = nProjects;

                for (const i in result)
                    html += web.getHandleBarHtml("project_nav", result[i]);

                if (which === "recentinvitedpatches")
                    html += "<div class=\"text-center\"><a class=\"button-small\" href=\"/myactivityfeed\">See all invites</a></div>";
                else
                    html += "<div class=\"text-center\"><a class=\"button-small\" href=\"/mypatches\">All my patches</a></div>";
            }
            dropDown.innerHTML = html;
        });
    }
}
